// extracted by mini-css-extract-plugin
export default {"subHeading":"_2D7T","trigger":"_21vy","triggerContent":"_3FBb"};